import AboutLayout from "./AboutLayout";
import ChairmanImg from "../../utils/images/chairman2.PNG";

function ChairmanMessage() {
  return (
    <AboutLayout
      title="Chairman's Message"
      image={ChairmanImg}
      name="Shafi Mohammad"
      designation="Chairman"
    >
      <p>Dear Parents,</p>

      <p>
        As the Chairman of IQRAA Public School, it is my privilege to welcome
        you to our vibrant community.
      </p>

      <p>
        Our school is committed to providing an exceptional education that
        prepares students for success in life. We believe in fostering an
        environment where every student can excel academically, socially, and
        emotionally.
      </p>

      <p>
        The partnership between the school, students, and their families is at
        the heart of our success. With your support, we are confident that we
        can continue to nurture the leaders of tomorrow.
      </p>
    </AboutLayout>
  );
}

export default ChairmanMessage;
